import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "onboarding-questionnaire__button-wrapper"
}

import { computed, onMounted, Raw, ref } from 'vue'

import { QuestionnaireView } from '@/models/onboarding'
import { onboardingPages } from '@/models/onboarding.pages'
import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'
import { AuthUser } from '@/models/interfaces.auth'
import { showNewOnboardingItems } from '@/services/ab'

import Logo from '@/components/ui/Logo.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import Stepper from '@/app/components/onboarding/Stepper.vue'
import Text from '@/app/components/onboarding/questionnaire/Text.vue'
import Options from '@/app/components/onboarding/questionnaire/Options.vue'
import FinishingSetup from '@/app/components/onboarding/questionnaire/FinishingSetup.vue'
import Review from '@/app/components/onboarding/questionnaire/Review.vue'
import Statements from '@/app/components/onboarding/questionnaire/Statements.vue'
import Books from '@/app/components/onboarding/questionnaire/Books.vue'
import DailyGoal from '@/app/components/onboarding/questionnaire/DailyGoal.vue'
import Notifications from '@/app/components/onboarding/questionnaire/Notifications.vue'
import CommitmentPact from '@/app/components/onboarding/questionnaire/CommitmentPact.vue'
import Welcome16167 from '@/app/components/onboarding/questionnaire/Welcome16167.vue'
import Splitscreen16167 from '@/app/components/onboarding/questionnaire/Splitscreen16167.vue'
import Upgrade16167 from '@/app/components/onboarding/questionnaire/Upgrade16167.vue'
import GenreSelection16167 from '@/app/components/onboarding/questionnaire/GenreSelection16167.vue'
import BookSelection16167 from '@/app/components/onboarding/questionnaire/BookSelection16167.vue'
import Loading16167 from '@/app/components/onboarding/questionnaire/Loading16167.vue'
import Summary16167 from '@/app/components/onboarding/questionnaire/Summary16167.vue'
import MillionUsers16167 from '@/app/components/onboarding/questionnaire/MillionUsers16167.vue'
import ProductDemo16167 from '@/app/components/onboarding/questionnaire/ProductDemo16167.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Questionnaire',
  props: {
    nextOnboardingPage: { type: Function }
  },
  setup(__props: any) {

const props = __props

const pageComponents = {
  Text,
  Options,
  FinishingSetup,
  Review,
  Statements,
  Books,
  DailyGoal,
  Notifications,
  CommitmentPact,
  Welcome16167,
  Splitscreen16167,
  Upgrade16167,
  GenreSelection16167,
  BookSelection16167,
  Loading16167,
  Summary16167,
  MillionUsers16167,
  ProductDemo16167,
}

const currentPageComponent = computed(() => {
  return pageComponents[view.value.currentPage.type]
})

const user = JSON.parse(localStorage.getItem('user') || '{}') as AuthUser
const firstName = user.full_name?.match(/^[a-zA-ZÀ-ÿ]+/)?.[0]

const view = ref<Raw<QuestionnaireView>>(
  new QuestionnaireView(
    onboardingPages.questionnaire,
    props.nextOnboardingPage,
    firstName,
  ),
)

onMounted(async () => {
  // Preload cache data while the user goes through the questionnaire.
  // We run it without `await` on purpose so that it doesn't block the
  // loading of the rest of the page.
  preloadCacheData()
})

async function preloadCacheData(): Promise<void> {
  try {
    await Promise.all([
      backend.getBooks(),
      backend.getArticles(),
      backend.getPodcasts(),
      backend.getBookCollections(),
      backend.getRecommendations(),
      backend.getExcerpt(),
      backend.getBookOfTheDay(),
      backend.getUserDocs(),
      backend.getBookTags(),
    ])
  } catch (error: any) {
    Sentry.captureException(error)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["onboarding-questionnaire", {
      'onboarding-questionnaire--16167': _unref(showNewOnboardingItems)(),
    }])
  }, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          key: `${view.value.currentSectionIndex !== 0}`,
          class: "onboarding-questionnaire__header"
        }, [
          (view.value.currentSectionIndex !== 0)
            ? (_openBlock(), _createBlock(Stepper, {
                key: 0,
                view: view.value
              }, null, 8, ["view"]))
            : (view.value.isLogoVisible)
              ? (_openBlock(), _createBlock(Logo, {
                  key: 1,
                  class: "onboarding-questionnaire__logo",
                  withText: true
                }))
              : _createCommentVNode("", true)
        ]))
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_resolveDynamicComponent(currentPageComponent.value), {
          key: view.value.currentPage.id,
          view: view.value
        }, null, 8, ["view"]))
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "button-fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (view.value.isContinueButtonVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(AppButton, {
                class: "onboarding-questionnaire__button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (view.value.continue()))
              }, {
                default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                  _createTextVNode("Continue", -1)
                ]))]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 2))
}
}

})